import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FilterReusableComp from "../../../components/FilterReusableComp";
import CurrencyText from "../../../components/fragment/cur-text/CurrencyText";
import PaginationFragment from "../../../components/fragment/pagination/PaginationFragment";
import StatusFragment from "../../../components/fragment/status/StatusFragment";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import { getCustomers, getCustomersCsv } from "../../../redux/customer";
import RootState from "../../../redux/type";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import "../../../styles/dashboard/customer/CustomersIndex.css";
import { formatTime } from "../../../utils/Helper";
import { systemRoles } from "../../../utils/roles";
import Skeleton from "react-loading-skeleton";
import ActionContext from "../../../context/ActionContext";
import RazorTable from "../../../components/razor-reuse/tables/RazorTable";
import RazorTableRow from "../../../components/razor-reuse/tables/RazorTableRow";
import DateRangeComponent from "../../../components/fragment/date-range/DateRangeComponent";
import TextColorFragment from "../../../components/fragment/text-color/TextColorFragment";

const CustomersIndex = () => {
  const actionCtx = useContext(ActionContext);
  const navigate = useNavigate();
  const { loading, customers } = useSelector(
    (state: RootState) => state.customer,
  );
  const { user } = useSelector((state: RootState) => state.auth);
  const [currentPageVal, setCurrentPage] = useState(1);
  const dispatch = useDispatch();

  const selectListOne = [
    { label: "Level Zero", value: "level-zero" },
    { label: "Level 1", value: "level-one" },
    { label: "Level 2", value: "level-two" },
    { label: "All Level", value: "" },
  ];

  const selectListTwo = [
    { label: "Signed Up", value: "signed_up" },
    { label: "Suspended", value: "suspended" },
    { label: "Active", value: "active" },
    { label: " Inactive", value: "inactive" },
    { label: "Blacklisted", value: "black_listed" },
    { label: "All ", value: "" },
  ];

  const [filterOneVal, setFilterOneVal] = useState<any>("");
  const [filterTwoVal, setFilterTwoVal] = useState<any>("");
  const [search, setSearch] = useState<string>("");
  const [dateRange, setDateRange] = useState("");

  const headerList = [
    "Full Name",
    "Email Address",
    "Verif. Status",
    "Bridge Status",
    "Account Status",
    "Date Created",
    "Country of Residence",
    "Last Activity",
  ];

  const cardList = [
    {
      text: "Signed Up Users",
      color: "rgba(92, 112, 175, 1)",
      number: customers?.count?.total || "0",
      link: "",
      onClick: () => {
        setFilterTwoVal(selectListTwo[0]);
      },
    },
    {
      text: "Active Users",
      color: "rgba(5, 148, 79, 1)",
      number: customers?.count?.active || "0",
      link: "",
      onClick: () => {
        setFilterTwoVal(selectListTwo[2]);
      },
    },
    {
      text: "Inactive Users",
      color: "rgba(255, 192, 67, 1)",
      number: customers?.count?.inactive || "0",
      link: "",
      onClick: () => {
        setFilterTwoVal(selectListTwo[3]);
      },
    },
    {
      text: "Suspended Users",
      color: "rgba(225, 25, 0, 1)",
      number: customers?.count?.suspended || "0",
      link: "",
      onClick: () => {
        setFilterTwoVal(selectListTwo[1]);
      },
    },
    {
      text: "Blacklisted Users",
      color: "rgba(225, 25, 0, 1)",
      number: customers?.count?.blacklisted || "0",
      link: "",
      onClick: () => {
        setFilterTwoVal(selectListTwo[4]);
      },
    },
  ];

  // useEffect to check if user has permission to view transactions
  useEffect(() => {
    if (
      !user?.permissions?.includes(systemRoles[3]) &&
      user?.permissions?.length > 0
    ) {
      navigate(ALL_ROUTES?.DASHBOARD_OVERVIEW);
    }
  }, [user?.permissions]);

  const obj = {
    page: currentPageVal,
    acc_status: filterTwoVal?.value || "",
    level_status: filterOneVal?.value || "",
    search: search,
    type: "customer",
    per_page: actionCtx?.perPage?.label,
    date: dateRange,
  };

  useEffect(() => {
    if (user?.permissions?.includes(systemRoles[3])) {
      dispatch(getCustomers(obj) as any);
    }
  }, [
    currentPageVal,
    filterOneVal,
    filterTwoVal,
    search,
    user?.permissions,
    dateRange,
    actionCtx?.perPage,
  ]);

  const formatOptionLabelTwo = ({ label, value }: any) => {
    if (value === "") {
      return label;
    } else {
      return (
        <>
          <StatusFragment
            text={value || ""}
            className={
              value === "active"
                ? "success"
                : value === "inactive"
                  ? "pending"
                  : value === "suspended"
                    ? "failed"
                    : value === "blacklisted"
                      ? "failed"
                      : ""
            }
          />
        </>
      );
    }
  };

  const removeSelectedList = (list: any) => {
    if (list?.length > 0) {
      const newlist = list?.filter(
        (chi: any) => chi?.label !== filterOneVal?.label,
      );
      const secondlist = newlist?.filter(
        (chi: any) => chi?.label !== filterTwoVal?.label,
      );
      return secondlist;
    }
  };

  return (
    <>
      <DashboardLayoutMain
        loading={Object?.keys(customers)?.length < 1 && loading}
        title="Mobile Users"
      >
        <div className="customers-index-wrapper-smart-send">
          {/* card preview box Inactive start */}
          <div className="cards-preview-box">
            {cardList?.map((chi, idx) => {
              return (
                <div
                  onClick={() => {
                    chi?.onClick?.();
                  }}
                  key={idx}
                  className="card-item"
                >
                  <p
                    style={{ color: chi?.color ? chi?.color : "" }}
                    className="text"
                  >
                    {chi?.text}
                  </p>
                  {loading ? (
                    <Skeleton className="number" width={30} height={30} />
                  ) : (
                    <p className="number">{chi?.number}</p>
                  )}
                </div>
              );
            })}
          </div>
          {/* card preview box end */}
          {/* filter section start */}
          <FilterReusableComp
            defaultSelectOne="Verification Status"
            selectOneList={selectListOne}
            onSelectOne={(param) => {
              setFilterOneVal(param);
              setCurrentPage(1);
            }}
            onSearch={(param: any) => {
              if (String(param)?.length > 2) {
                setSearch(param);
              }
              if (String(param)?.length < 1) {
                setSearch("");
              }
            }}
            selectOneValue={filterOneVal}
            onSelectTwo={(param) => {
              setFilterTwoVal(param);
              setCurrentPage(1);
            }}
            selectTwoValue={filterTwoVal}
            // formatOptionLabelTwo={formatOptionLabelTwo}
            defaultSelectTwo="Account Status"
            selectTwoList={removeSelectedList(selectListTwo)}
            searchPlaceholder="Search by Username, Email, Country"
            onExport={() => {
              dispatch(getCustomersCsv(obj) as any);
            }}
            moreComponents={
              <>
                <DateRangeComponent
                  onSet={(param) => {
                    setDateRange(param);
                  }}
                  value={dateRange}
                  onCancel={() => {
                    setDateRange("");
                  }}
                  // onOpen={}
                />
              </>
            }
          />
          {/* filter section end */}
          {/* table section start */}
          <div
            onClick={() => {
             
            }}
            className="table-section-box"
          >
            <RazorTable tableStrip={true} headerList={headerList}>
              {customers?.customers?.data?.map((chi: any, idx: any) => {
                return (
                  <RazorTableRow
                    onRowClick={() => {
                      if (user?.permissions?.includes(systemRoles[3])) {
                        localStorage?.setItem("cors_key", chi?.id);
                        navigate(ALL_ROUTES?.DASHBOARD_CUSTOMER_SINGLE);
                      }
                    }}
                    loading={loading}
                    key={idx}
                    one={`${chi?.first_name || ""} ${chi?.last_name || ""} `}
                    two={chi?.email}
                    three={chi?.verification_status?.replace("-", " ") || "---"}
                    four={chi?.bridge_customer_status || "---"}
                    five={
                      <TextColorFragment
                        text={chi?.account_status || ""}
                        color={
                          chi?.account_status === "active"
                            ? "rgba(0, 153, 51, 1)"
                            : chi?.account_status === "inactive"
                              ? "rgba(255, 192, 67, 1)"
                              : chi?.account_status === "Suspended"
                                ? "rgba(200, 16, 46, 1)"
                                : ""
                        }
                      />
                    }
                    six={formatTime(chi?.created_at)}
                    seven={
                      <CurrencyText
                        // currency={chi?.location?.name || "ngn"}
                        text={chi?.location?.name}
                        url={chi?.location?.flag_url}
                        imgSize="2rem"
                        // className="currency-text-country"
                      />
                    }
                    eight={`View details`}
                  />
                );
              })}
            </RazorTable>
          </div>

          {/* table section end */}
          {/* pagination start */}
          <PaginationFragment
            currentPage={customers?.customers?.meta?.current_page || 1}
            perPage={customers?.customers?.meta?.per_page}
            totalPage={customers?.customers?.meta?.total}
            onPageChange={(num) => {
              setCurrentPage(num);
            }}
            hidePagination={loading}
            showPerPage
          />
          {/* pagination  end */}
        </div>
      </DashboardLayoutMain>
    </>
  );
};

export default CustomersIndex;
